import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Box, useTheme, Typography } from "@mui/material";
import { tokens } from "../../../theme";
import Autocomplete from '@mui/material/Autocomplete';
import Axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import { getAuthHeader } from '../../../utils/authToken';

const AddTeacherModal = ({ 
    setAnchorEl, 
    course, 
    setInfoUpdated, 
    setBackdropOpen,
    setSuccessAlertOpen,
    setSuccessAlertMessage,
    setErrorAlertOpen,
    setErrorAlertMessage
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [firstRender, setFirstRender] = React.useState(true);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); setAnchorEl(null); };

    const [addTeacher, setAddTeacher] = React.useState(null);
    const [teachersNotInCourse, setTeachersNotInCourse] = React.useState(null);

    async function fetchTeachersNotInCourse() {
        await Axios.get(`${process.env.REACT_APP_URL}/api/v1/courses/${course.uuid}/other-teachers`, {
            headers: {
                Authorization: getAuthHeader(),
            },
        }).then((response) => {
            setTeachersNotInCourse(response.data.map((teacher) => {
                return {
                    id: teacher.id,
                    uuid: teacher.uuid,
                    name: teacher.first_name + " " + teacher.last_name
                }
            }));

            setFirstRender(false);
        }).catch((error) => {
            setErrorAlertMessage(error.response?.data?.message || "Something went wrong");
            setErrorAlertOpen(true);
            setFirstRender(false);
        });
    }

    if (firstRender)
        fetchTeachersNotInCourse();

    const handleAddTeacher = async () => {
        if (addTeacher === null) {
            setErrorAlertMessage("Please select a teacher.");
            setErrorAlertOpen(true);
            return;
        }

        setBackdropOpen(true);
        Axios.post(`${process.env.REACT_APP_URL}/api/v1/courses/${course.uuid}/teachers/${addTeacher.uuid}`, {
            
        }, {
            headers: {
                Authorization: getAuthHeader(),
            },
        }).then((response) => {
            setSuccessAlertMessage(response.data.message);
            setSuccessAlertOpen(true);
            setBackdropOpen(false);
            setInfoUpdated(true);
            handleClose();
        }).catch((error) => {
            setErrorAlertMessage(error.response?.data?.message || "Something went wrong");
            setErrorAlertOpen(true);
            setBackdropOpen(false);
        });
    };


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        maxHeight: '90vh',
        overflowY: 'auto',
        bgcolor: colors.primary[600],
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <div>
            <Button onClick={handleOpen} sx={{ p: 1, width: "100%" }}>Add Teacher</Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography variant="h4" color={colors.primary[450]}>
                            Add a teacher to {course.course_title}
                        </Typography>
                        <CloseIcon sx={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }} onClick={handleClose} />
                        <Box display="flex" flexDirection="column" gap={3} width="100%" pt={2}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo-1"
                                    getOptionLabel={(option) => option.name}
                                    getOptionKey={(option) => option.id}
                                    options={teachersNotInCourse !== null ? teachersNotInCourse : []}
                                    renderInput={(params) => <TextField {...params} label="Add Teacher" />}
                                    onChange={(event, value) => setAddTeacher(value)}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    sx={{ width: "70%", mt: 1 }}
                                />
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    sx={{ mt: 2, width: "7rem" }}
                                    onClick={handleAddTeacher}
                                >
                                    Add
                                </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    )
}

export default AddTeacherModal